import React, { useEffect } from "react";
import { Row, Col } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getErrorMessage } from "../../Redux/Actions/errorMessage";

const DashboardMeasures = () => {
  const dispatch = useDispatch();

  const totalMeasuredCostsYear1 = useSelector(
    (state) => state.TotalMeasuredCostsYear.year1
  );
  const totalMeasuredCostsYear2 = useSelector(
    (state) => state.TotalMeasuredCostsYear.year2
  );
  const totalMeasuredCostsYear3 = useSelector(
    (state) => state.TotalMeasuredCostsYear.year3
  );
  const totalMeasuredHoursYear1 = useSelector(
    (state) => state.TotalMeasuredHoursYear.year1
  );
  const totalMeasuredHoursYear2 = useSelector(
    (state) => state.TotalMeasuredHoursYear.year2
  );
  const totalMeasuredHoursYear3 = useSelector(
    (state) => state.TotalMeasuredHoursYear.year3
  );
  const netProfitPerMonthYear1 = useSelector(
    (state) => state.salaryCalculationYear1.netProfitPerMonth
  );
  const netProfitPerMonthYear2 = useSelector(
    (state) => state.salaryCalculationYear2.netProfitPerMonth
  );
  const netProfitPerMonthYear3 = useSelector(
    (state) => state.salaryCalculationYear3.netProfitPerMonth
  );

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (
        totalMeasuredHoursYear1 >= 1750 ||
        totalMeasuredHoursYear2 >= 1750 ||
        totalMeasuredHoursYear3 >= 1750
      ) {
        dispatch(
          getErrorMessage("Åtgärdstimmar bör ej överstiga 1750 timmar per år!")
        );
      } else if (
        totalMeasuredHoursYear1 <= 1750 ||
        totalMeasuredHoursYear2 <= 1750 ||
        totalMeasuredHoursYear3 <= 1750
      ) {
        dispatch(getErrorMessage(""));
      }
    }
  }, [
    dispatch,
    totalMeasuredHoursYear1,
    totalMeasuredHoursYear2,
    totalMeasuredHoursYear3,
  ]);

  function addSumTotalHours() {
    let total =
      totalMeasuredHoursYear1 +
      totalMeasuredHoursYear2 +
      totalMeasuredHoursYear3;
    if (total) {
      //hide decimal if none
      // if (total % 1 === 0) {
      //   return (total = parseInt(total, 10));
      // } else {
      //   return (total = parseFloat(total, 10).toFixed(1));
      // }
      return total;
    } else {
      return 0;
    }
  }
  function addSumTotalCosts() {
    let total =
      totalMeasuredCostsYear1 +
      totalMeasuredCostsYear2 +
      totalMeasuredCostsYear3;
    if (total) {
      //hide decimal if none
      // if (total % 1 === 0) {
      //   return (total = parseInt(total, 10));
      // } else {
      //   return (total = parseFloat(total, 10).toFixed(1));
      // }
      return total;
    } else {
      return 0;
    }
  }
  // function hideDecimalIfNone(value) {
  //   var amount = value;
  //   if (amount % 1 === 0) {
  //     return (amount = parseInt(amount, 10));
  //   } else {
  //     return (amount = parseFloat(amount, 10).toFixed(1));
  //   }
  // }

  return (
    <>
      <Col xs={9} className="offset-9">
        <Row>
          <Col
            xs={28}
            className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
          >
            Åtgärdstimmar År 1
          </Col>
          <Col xs={12} style={{ padding: "0px" }}>
            <output className="form-control text-center dashboard-output">
              {Math.round(
                totalMeasuredHoursYear1 > 0 ? totalMeasuredHoursYear1 : 0
              )}
            </output>
          </Col>
        </Row>
        <Row>
          <Col
            xs={28}
            className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
          >
            Åtgärdstimmar År 2
          </Col>
          <Col xs={12} style={{ padding: "0px" }}>
            <output className="form-control text-center dashboard-output">
              {Math.round(
                totalMeasuredHoursYear2 > 0 ? totalMeasuredHoursYear2 : 0
              )}
            </output>
          </Col>
        </Row>
        <Row>
          <Col
            xs={28}
            className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
          >
            Åtgärdstimmar År 3
          </Col>
          <Col xs={12} style={{ padding: "0px" }}>
            <output className="form-control text-center dashboard-output">
              {Math.round(
                totalMeasuredHoursYear3 > 0 ? totalMeasuredHoursYear3 : 0
              )}
            </output>
          </Col>
        </Row>
        <Row>
          <Col
            xs={28}
            className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
          >
            Samtliga Åtgärdstimmar
          </Col>
          <Col xs={12} style={{ padding: "0px" }}>
            <output className="form-control text-center dashboard-output">
              {addSumTotalHours()}
            </output>
          </Col>
        </Row>
      </Col>

      <Col xs={9}>
        <Row>
          <Col
            xs={28}
            className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
          >
            Åtgärdskostnader År 1
          </Col>
          <Col xs={12} style={{ padding: "0px" }}>
            <output className="form-control text-center dashboard-output">
              {Math.round(
                totalMeasuredCostsYear1 > 0 ? totalMeasuredCostsYear1 : 0
              )}
            </output>
          </Col>
        </Row>
        <Row>
          <Col
            xs={28}
            className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
          >
            Åtgärdskostnader År 2
          </Col>
          <Col xs={12} style={{ padding: "0px" }}>
            <output className="form-control text-center dashboard-output">
              {Math.round(
                totalMeasuredCostsYear2 > 0 ? totalMeasuredCostsYear2 : 0
              )}
            </output>
          </Col>
        </Row>
        <Row>
          <Col
            xs={28}
            className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
          >
            Åtgärdskostnader År 3
          </Col>
          <Col xs={12} style={{ padding: "0px" }}>
            <output className="form-control text-center dashboard-output">
              {Math.round(
                totalMeasuredCostsYear3 > 0 ? totalMeasuredCostsYear3 : 0
              )}
            </output>
          </Col>
        </Row>
        <Row>
          <Col
            xs={28}
            className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
          >
            Samtliga Åtgärdskostn.
          </Col>
          <Col xs={12} style={{ padding: "0px" }}>
            <output className="form-control text-center dashboard-output">
              {addSumTotalCosts()}
            </output>
          </Col>
        </Row>
      </Col>

      <Col xs={7} className="offset-1">
        <Row>
          <Col
            xs={23}
            className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
          >
            Månadslön År 1
          </Col>
          <Col xs={17} style={{ padding: "0px" }}>
            <output className="form-control text-center dashboard-output">
              {Math.round(
                netProfitPerMonthYear1 > 0 ? netProfitPerMonthYear1 : 0
              )}
            </output>
          </Col>
        </Row>
        <Row>
          <Col
            xs={23}
            className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
          >
            Månadslön År 2
          </Col>
          <Col xs={17} style={{ padding: "0px" }}>
            <output className="form-control text-center dashboard-output">
              {Math.round(
                netProfitPerMonthYear2 > 0 ? netProfitPerMonthYear2 : 0
              )}
            </output>
          </Col>
        </Row>
        <Row>
          <Col
            xs={23}
            className="d-flex align-items-center justify-content-end small fw-bold dashboard-heading responsive-fontsize"
          >
            Månadslön År 3
          </Col>
          <Col xs={17} style={{ padding: "0px" }}>
            <output className="form-control text-center dashboard-output">
              {Math.round(
                netProfitPerMonthYear3 > 0 ? netProfitPerMonthYear3 : 0
              )}
            </output>
          </Col>
        </Row>
      </Col>
    </>
  );
};
export default DashboardMeasures;
